/**
 * Individuelle 1:1-Coaching-Termine (Mandantenakte → PEOne-Kalender).
 * Unabhängig von Gruppen-Events (`system_events` / EventModel).
 */
export interface CoachingAppointment {
  id: string;
  clientId: string;
  title: string; // z.B. "Kalkulationsgespräch", "Teammeeting", "Strategie-Audit"
  datum: string; // YYYY-MM-DD
  uhrzeit: string; // HH:mm
  dauerMinuten?: number;
  meetingLink: string; // z.B. Zoom, Google Meet
  coachName: string;
  coachAvatarUrl?: string; // Bild des jeweiligen Coaches
  /** Optional: Team-Member-ID für Zuordnung */
  coachId?: string;
  notizen?: string;
  createdAt: string;
  updatedAt?: string;
}

export const COACHING_APPOINTMENTS_COLLECTION = 'coaching_appointments';

export const COACHING_TITLE_PRESETS = [
  'Kalkulationsgespräch',
  'Teammeeting',
  'Strategie-Audit',
  'Onboarding',
  'Follow-up',
  'Sonstiges',
] as const;
